export enum SportsWidgetType {
  SportsAnimalRacingLandingPage = 'sports_animal_racing_landing_page',
  SportsAnimalRacingMeetings = 'sports_animal_racing_meetings',
  SportsAnimalRacingSpecialsPage = 'sports_animal_racing_specials_page',
  SportsAntePostEvents = 'sports_ante_post_events',
  SportsAntePostMarket = 'sports_ante_post_market',
  SportsBreadcrumbs = 'sports_breadcrumbs',
  SportsCmsBanner = 'sports_cms_banner',
  SportsCompetitionEvents = 'sports_competition_events',
  SportsCompetitionOutrights = 'sports_competition_outrights',
  SportsCompetitions = 'sports_competitions',
  SportsEventInfo = 'sports_event_info',
  SportsEventPage = 'sports_event_page',
  SportsEventTypeInfo = 'sports_event_type_info',
  SportsEventTypeSpecials = 'sports_event_type_specials',
  SportsFeatured = 'sports_featured',
  SportsFeaturedFilters = 'sports_featured_filters',
  SportsGolfMatches = 'sports_golf_matches',
  SportsHistoricalBets = 'sports_historical_bets',
  SportsHomeInPlay = 'sports_home_in_play',
  SportsHomePage = 'sports_home_page',
  SportsInPlayEvents = 'sports_in_play_events',
  SportsLandingPage = 'sports_landing_page',
  SportsMarkets = 'sports_markets',
  SportsMatchFiltering = 'sports_match_filtering',
  SportsMenu = 'sports_menu',
  SportsMyBets = 'sports_my_bets',
  SportsNextRaces = 'sports_next_races',
  SportsOddsBoost = 'sports_odds_boost',
  SportsPageNotFound = 'sports_page_not_found',
  SportsPromotion = 'sports_promotion',
  SportsPromotionDetails = 'sports_promotion_details',
  SportsPromotionGrid = 'sports_promotion_grid',
  SportsQuickLinks = 'sports_quick_links',
  SportsRaceCard = 'sports_race_card',
  SportsRaceInfo = 'sports_race_info',
  SportsRacePage = 'sports_race_page',
  SportsSelfExcludedInfo = 'sports_self_excluded_info',
  SportsSEO = 'sports_seo',
  SportsSettings = 'sports_settings',
  SportsSportInPlayEvents = 'sports_sport_in_play_events',
  SportsUpcomingEvents = 'sports_upcoming_events'
}
